const urls = {
  trucker: {
    searchTrucker: 'trucker/search',
    profile: 'trucker',
  },
  tracking: {
    jaiminho: 'tracking/tracking',
  },
  contactList: {
    contact: 'trucker/contact',
  },
  flagr: {
    checkFeature: 'company/check-feature-flag',
  },
  riskManagement: {
    lastConsultations: 'trucker/:truckerId/gr',
  },
  user: {
    me: 'user/me',
  },
  featureAccess: 'company/features-access',
};

export { urls };
